import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectUser } from '../../../redux/reducers/userReducer';

function PlanStatusView() {
  const navigate = useNavigate();
  const user = useSelector(selectUser);

  const subscriptionPlan = user?.data?.subscriptionPlan;

  let message = '';
  if (subscriptionPlan?.status === 'expired') {
    message = 'Your plan expired';
  } else if (subscriptionPlan?.type === 'trial') {
    const currentDate = new Date();
    const trialEndDate = new Date(subscriptionPlan?.endDate._seconds * 1000);
    const daysLeft = Math.ceil(
      (trialEndDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24)
    );
    if (daysLeft <= 5) {
      message = `Your trial expire in ${daysLeft} days`;
    }
  }

  if (!message) {
    return <></>;
  }

  return (
    <div
      style={{
        padding: '10px 15px',
        backgroundColor: '#E7EBEF',
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          fontSize: 16,
          color: '#3C5C7E',
          display: 'flex',
          alignItems: 'center',
          fontWeight: '700',
          fontFamily: 'Nunito Sans',
        }}
      >
        <img
          style={{ marginRight: 5 }}
          src='./assets/subscription_strip_ic.svg'
          alt='icon'
        />
        {message}
      </div>
      <div
        style={{
          fontSize: 14,
          color: '#3C5C7E',
          fontWeight: '700',
          fontFamily: 'Nunito Sans',
          cursor: 'pointer',
        }}
        onClick={() => navigate('/SubscriptionPlans')}
      >
        {'Become a Subscriber >'}
      </div>
    </div>
  );
}

export default PlanStatusView;
